import React from 'react';
import { useActiveAccount } from '../../../../hooks/useActiveAccount';

type Props = {
  children: React.ReactNode;
};

const OnlyRenderForFountainlife = ({ children }: Props) => {
  const activeAccount = useActiveAccount();
  // use startsWith to render in fountainlife and fountainlifetest
  return activeAccount?.id?.startsWith('fountainlife') ? <>{children}</> : null;
};

export default OnlyRenderForFountainlife;
